import React from 'react';
import styled from '@emotion/styled';
import { useTrackEvent } from 'tracking/useTrackEvent';
import { Button, Colors } from '@zapier/design-system';
import { mediaQueries } from 'components/mediaQueries';
import { Link } from 'components/Link/Link';

export const SignupPopup = () => {
  const trackEvent = useTrackEvent();

  return (
    <Outer>
      <Heading>Try Zapier free</Heading>
      <Details>Getting started is easy! no credit card required.</Details>
      <Actions>
        <ButtonWrapper>
          <Button
            href="/sign-up"
            hasShadow={true}
            isFullWidth={true}
            onClick={() =>
              trackEvent('call_to_action', {
                path: window.location.pathname,
                from_path: document.referrer,
                cta_name: 'signup_pre_intent',
                cta_raw_text: 'sign up',
                cta_location: 'popup',
                cta_goal: 'signup',
                signup_type: '',
                link_destination: '/sign-up',
              })
            }
          >
            Sign up
          </Button>
        </ButtonWrapper>
        <StyledLink href="/how-it-works">Learn more</StyledLink>
      </Actions>
    </Outer>
  );
};

const Outer = styled.div`
  display: grid;
  grid-row-gap: 10px;
  padding: 0 8%;
  ${mediaQueries.tablet} {
    grid-column-gap: 15%;
    grid-template-columns: repeat(2, max-content);
    place-content: center;
    place-items: center;
  }
  ${mediaQueries.desktop} {
    grid-template-columns: 1fr;
    padding: 0;
    place-items: baseline;
  }
`;

const Heading = styled.p`
  color: ${Colors.grey900};
  font-weight: bold;
  font-size: 16px;
  line-height: 150%;
`;

const Details = styled.p`
  display: none;
  ${mediaQueries.desktop} {
    color: ${Colors.grey700};
    display: block;
    font-size: 11px;
    line-height: 130%;
  }
`;

const Actions = styled.div`
  display: grid;
  grid-template-areas: 'button link';
  grid-template-columns: repeat(2, max-content);
  grid-column-gap: 15px;
  place-items: center;
  ${mediaQueries.tablet} {
    grid-template-areas: 'link button';
  }
  ${mediaQueries.desktop} {
    grid-template-areas: 'button link';
  }
`;

const ButtonWrapper = styled.div`
  grid-area: button;
`;

const StyledLink = styled(Link)`
  color: ${Colors.blue500};
  font-size: 14px;
  grid-area: link;
  line-height: 20px;
  font-weight: bold;
`;
